import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Register() {
    const { user, register } = useAuth();
    const [form, setForm] = useState({
        name: "",
        email: "",
        password: "",
        company_name: "",
    });
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    if (user) return <Navigate to="/dashboard" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        const res = await register(form);
        setLoading(false);
        if (!res.ok) {
            setErr(res.error);
            toast.error(res.error);
        } else {
            toast.success("Registrazione completata");
            nav("/onboarding");
        }
    };

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    return (
        <div className="min-h-screen flex items-center justify-center p-8 bg-white">
            <form
                onSubmit={submit}
                className="w-full max-w-md"
                data-testid="register-form"
            >
                <div className="overline mb-4">Registrazione</div>
                <h1 className="text-5xl font-black tracking-tighter mb-10">
                    Crea account.
                </h1>

                <label className="block mb-4">
                    <div className="overline mb-2">Nome azienda</div>
                    <input
                        className="inp"
                        value={form.company_name}
                        onChange={set("company_name")}
                        required
                        data-testid="register-company-input"
                    />
                </label>
                <label className="block mb-4">
                    <div className="overline mb-2">Il tuo nome</div>
                    <input
                        className="inp"
                        value={form.name}
                        onChange={set("name")}
                        required
                        data-testid="register-name-input"
                    />
                </label>
                <label className="block mb-4">
                    <div className="overline mb-2">Email</div>
                    <input
                        type="email"
                        className="inp"
                        value={form.email}
                        onChange={set("email")}
                        required
                        data-testid="register-email-input"
                    />
                </label>
                <label className="block mb-8">
                    <div className="overline mb-2">Password (min 6)</div>
                    <input
                        type="password"
                        className="inp"
                        minLength={6}
                        value={form.password}
                        onChange={set("password")}
                        required
                        data-testid="register-password-input"
                    />
                </label>

                {err && (
                    <div className="mb-4 p-3 border border-red-600 text-red-600 text-sm">
                        {err}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={loading}
                    className="btn-primary w-full"
                    data-testid="register-submit-button"
                >
                    {loading ? "Creazione…" : "Crea account"}
                </button>

                <div className="mt-8 text-sm text-zinc-600">
                    Hai già un account?{" "}
                    <Link
                        to="/login"
                        className="font-bold underline underline-offset-4"
                    >
                        Accedi
                    </Link>
                </div>
            </form>
        </div>
    );
}
